export const ZIPCODE_REGEX = /^[0-9]{7}$/;

export const LANGUAGE = {
  JA: 'ja',
  EN: 'en',
};

export const LANGUAGES_VALUE = [
  { id: 1, messageKey: 'ja' },
  { id: 2, messageKey: 'en' },
];

type Keys = keyof typeof LANGUAGE;
export type languageType = typeof LANGUAGE[Keys]